module.exports = __webpack_public_path__ + "assets/images/chef_01_04cb2c7c2cd5d0ab31387398b9bb78cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/chef_01.png
// module id = 183
// module chunks = 0